'use client'

import { getClient } from '@/lib/ApolloClient/getClient'
import React, { FC, useEffect, useState } from 'react'
import { Store, StoreProviderProps } from '~types/index'
import saveStoreData from './saveStoreData'
import { getStoreService } from './services'

type updateStoreProps = (storeId: string) => Promise<void>

export const StoreContext = React.createContext<{
  store: Store
  updateStore: (store: string) => void
}>({
  store: {
    reference: '',
    code: '',
    name: '',
    id: '',
  },
  updateStore: console.log,
})

export const useStoreContext = () => React.useContext(StoreContext)

export const StoreProvider: FC<StoreProviderProps> = ({
  children,
  store: storeSSR,
  clientId,
}) => {
  const [store, setStore] = useState<Store>({
    ...storeSSR,
    reference: storeSSR.code,
  })

  useEffect(() => {
    saveStoreData(store)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [, setLoading] = useState<boolean>(false)

  const clientApollo = getClient({ onError: console.error })

  const updateStore: updateStoreProps = async (storeId) => {
    setLoading(true)
    await getStoreService({
      clientApollo,
      setStore,
      clientId,
      storeId,
      setLoading,
    })
  }

  return (
    <StoreContext.Provider value={{ store, updateStore }}>
      {children}
    </StoreContext.Provider>
  )
}
